// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bdc04609","351":"155e446d","453":"804f5d00","505":"a81de2ba","732":"518dd1e9"}[chunkId] + ".chunk.js";
};